import type {
  LeaseComp,
  LeaseCompFieldRule,
} from "@/features/leaseComps/types/leaseComps.types";
import { createApi } from "@reduxjs/toolkit/query/react";
import { interactiveSurveyBaseQuery } from "./base";

export const leaseCompsApi = createApi({
  reducerPath: "leaseCompsApi",
  baseQuery: interactiveSurveyBaseQuery,
  tagTypes: ["LeaseComps", "LeaseCompFieldRule"],
  endpoints: (build) => ({
    getLeaseComps: build.query<LeaseComp[], string>({
      query: (surveyId) => ({
        url: `leaseComp/${surveyId}/all`,
      }),
      providesTags: [{ type: "LeaseComps", id: "LIST" }],
    }),
    getLeaseCompFieldRule: build.query<LeaseCompFieldRule[], string>({
      query: (surveyId) => ({
        url: `leaseComp/${surveyId}/leasecompfieldrule`,
      }),
      providesTags: [{ type: "LeaseCompFieldRule", id: "LIST" }],
    }),
  }),
});

export const { useGetLeaseCompsQuery, useGetLeaseCompFieldRuleQuery } =
  leaseCompsApi;
